import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DecimalService {
  limitarDecimales(event: any, numero: number) {
    const value = event.target.value;
    if (value % 1 != 0) {
      // si el número es decimal
      const decimalCount = (value.split(".")[1] || []).length;
      const maxDecimals = decimalCount > numero ? numero : decimalCount;
      event.target.value = parseFloat(value).toFixed(maxDecimals);
    }
  }
}
